(function () {
    window.NewsGraph = window.NewsGraph || {};

    window.NewsGraph.SECTOR_INFO = {
        'XLK':  { name: 'Technology',              color: 'hsl(196, 80%, 50%)' },
        'XLV':  { name: 'Healthcare',              color: 'hsl(131, 80%, 50%)' },
        'XLY':  { name: 'Consumer Discretionary',  color: 'hsl(327, 80%, 50%)' },
        'XLI':  { name: 'Industrials',             color: 'hsl(229, 80%, 50%)' },
        'XLC':  { name: 'Communication',           color: 'hsl(262, 80%, 50%)' },
        'XLP':  { name: 'Consumer Staples',        color: 'hsl(295, 80%, 50%)' },
        'XLF':  { name: 'Financials',              color: 'hsl(98,  80%, 50%)' },
        'XLB':  { name: 'Materials',               color: 'hsl(65,  80%, 50%)' },
        'XLRE': { name: 'Real Estate',             color: 'hsl(164, 80%, 50%)' },
        'XLE':  { name: 'Energy',                  color: 'hsl(33,  80%, 50%)' },
        'XLU':  { name: 'Utilities',               color: 'hsl(0,   80%, 50%)' },
    };

    const SECTOR_ORDER = ['XLK', 'XLV', 'XLY', 'XLI', 'XLC', 'XLP', 'XLF', 'XLB', 'XLRE', 'XLE', 'XLU'];

    const SECTOR_ALIAS_MAP = {
        'XLK': 'XLK', 'TECHNOLOGY': 'XLK', 'TECH': 'XLK',
        'XLV': 'XLV', 'HEALTHCARE': 'XLV', 'HEALTH CARE': 'XLV',
        'XLY': 'XLY', 'CONSUMER DISCRETIONARY': 'XLY', 'DISCRETIONARY': 'XLY',
        'XLI': 'XLI', 'INDUSTRIALS': 'XLI', 'INDUSTRIAL': 'XLI',
        'XLC': 'XLC', 'COMMUNICATION': 'XLC', 'COMMUNICATION SERVICES': 'XLC', 'COMMUNICATIONS': 'XLC',
        'XLP': 'XLP', 'CONSUMER STAPLES': 'XLP', 'STAPLES': 'XLP',
        'XLF': 'XLF', 'FINANCIALS': 'XLF', 'FINANCIAL': 'XLF', 'FINANCE': 'XLF',
        'XLB': 'XLB', 'MATERIALS': 'XLB', 'BASIC MATERIALS': 'XLB',
        'XLRE': 'XLRE', 'REAL ESTATE': 'XLRE', 'REALESTATE': 'XLRE',
        'XLE': 'XLE', 'ENERGY': 'XLE',
        'XLU': 'XLU', 'UTILITIES': 'XLU', 'UTILITY': 'XLU',
    };

    window.NewsGraph.compute2DLayout = function (nodes, data) {
        const narrativeNodes = nodes.filter(n =>  window.NewsGraph.NARRATIVE_TYPES.has(n.type));
        const tickerNodes    = nodes.filter(n => !window.NewsGraph.NARRATIVE_TYPES.has(n.type));

        const sectorsMap       = {};
        const noSectorTickers  = [];

        tickerNodes.forEach(node => {
            const rawTicker = (data.tickers || []).find(t => {
                if (!t) return false;
                const sym = String(t.symbol || t.id || '').toUpperCase().trim();
                const nodeSym = String(node.label || node.symbol || node.id || '').split(' - ')[0].toUpperCase().trim();
                const nodeId = String(node.id || '').toUpperCase().trim();
                return (sym && sym === nodeSym) || (t.id && String(t.id).toUpperCase().trim() === nodeId);
            });
            const rawSec = String(
                rawTicker?.sector_proxy_symbol || rawTicker?.sector_proxy || rawTicker?.sector || rawTicker?.sector_name ||
                node?.sector_proxy_symbol || node?.sector_proxy || node?.sector || node?.sector_name || ''
            ).toUpperCase().trim();
            const sectorProxy = SECTOR_ALIAS_MAP[rawSec] || (SECTOR_ORDER.includes(rawSec) ? rawSec : null);

            if (sectorProxy) {
                if (!sectorsMap[sectorProxy]) sectorsMap[sectorProxy] = [];
                sectorsMap[sectorProxy].push(node);
            } else {
                noSectorTickers.push(node);
            }
        });

        let activeSectorProxies = Object.keys(sectorsMap).sort((a, b) => {
            return SECTOR_ORDER.indexOf(a) - SECTOR_ORDER.indexOf(b);
        });

        if (activeSectorProxies.length === 0 && tickerNodes.length > 0) {
            const defaultSectors = ['XLK', 'XLV', 'XLY', 'XLI'];
            noSectorTickers.forEach((node, idx) => {
                const sec = defaultSectors[idx % defaultSectors.length];
                if (!sectorsMap[sec]) sectorsMap[sec] = [];
                sectorsMap[sec].push(node);
            });
            noSectorTickers.length = 0;
            activeSectorProxies = Object.keys(sectorsMap).sort((a, b) => {
                return SECTOR_ORDER.indexOf(a) - SECTOR_ORDER.indexOf(b);
            });
        }

        const sortedTickerNodes = [];
        activeSectorProxies.forEach(sec => {
            sectorsMap[sec].sort((a, b) => (a.label || a.id || '').localeCompare(b.label || b.id || ''));
            sortedTickerNodes.push(...sectorsMap[sec]);
        });
        noSectorTickers.sort((a, b) => (a.label || a.id || '').localeCompare(b.label || b.id || ''));
        sortedTickerNodes.push(...noSectorTickers);

        return { narrativeNodes, tickerNodes, sortedTickerNodes, activeSectorProxies, sectorsMap };
    };

    window.NewsGraph.computeTickerRingPositions = function (sortedTickerNodes, radius = 4.0) {
        const M = sortedTickerNodes.length;
        return sortedTickerNodes.map((node, i) => {
            const angle = (i / Math.max(M, 1)) * Math.PI * 2;
            return {
                node,
                angle,
                x: radius * Math.cos(angle),
                y: radius * Math.sin(angle),
            };
        });
    };

    window.NewsGraph.computeNarrativeRingPositions = function (narrativeNodes, radius = 2.0) {
        const N = narrativeNodes.length;
        return narrativeNodes.map((node, j) => {
            const angle = (j / Math.max(N, 1)) * Math.PI * 2;
            return {
                node,
                angle,
                x: radius * Math.cos(angle),
                y: radius * Math.sin(angle),
            };
        });
    };

    window.NewsGraph.computeSectorArcs = function (
        sortedTickerNodes,
        sectorsMap,
        activeSectorProxies,
        innerRadius = 3.65,
        outerRadius = 4.35
    ) {
        const M = sortedTickerNodes.length;
        const SECTOR_INFO = window.NewsGraph.SECTOR_INFO;
        const arcs = [];

        activeSectorProxies.forEach(sec => {
            const sectorNodes = sectorsMap[sec];
            const firstIdx    = sortedTickerNodes.indexOf(sectorNodes[0]);
            const lastIdx     = sortedTickerNodes.indexOf(sectorNodes[sectorNodes.length - 1]);

            const startAngle = (firstIdx / Math.max(M, 1)) * Math.PI * 2 - Math.PI / Math.max(M, 1);
            const endAngle   = (lastIdx  / Math.max(M, 1)) * Math.PI * 2 + Math.PI / Math.max(M, 1);
            let arcLen = endAngle - startAngle;
            if (arcLen < 0) arcLen += Math.PI * 2;

            const info = SECTOR_INFO[sec] || { name: 'Other', color: '#6b7280' };

            arcs.push({
                proxy: sec,
                name:  info.name,
                color: info.color,
                startAngle,
                endAngle,
                arcLen,
                midAngle: startAngle + arcLen / 2,
                innerRadius,
                outerRadius,
            });
        });

        return arcs;
    };
})();
